// extracted by mini-css-extract-plugin
export default {"container":"App_container__ZdBeZ","clock":"App_clock__KCHPO","regionSelector":"App_regionSelector__HIniN","sidebar":"App_sidebar__mQ96h","sidebarIcon":"App_sidebarIcon__eLAmV"};